import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import GoogleSans from "./GoogleSans-Regular.woff2";

export const GoogleSansFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: GoogleSans,
  },
];
